var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1933_2621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50488 0.75L6.50488 1.57575C4.79563 1.9245 3.50488 3.4395 3.50488 5.25L3.50488 14.25C3.50488 16.3177 5.18713 18 7.25488 18L11.7549 18C13.8226 18 15.5049 16.3177 15.5049 14.25L15.5049 5.25C15.5049 3.4395 14.2141 1.92375 12.5049 1.57575L12.5049 0.75C12.5049 0.336 12.1689 -3.78715e-07 11.7549 -3.60619e-07L7.25488 -1.63918e-07C6.84088 -1.45821e-07 6.50488 0.336 6.50488 0.75ZM14.0049 5.25L14.0049 14.25C14.0049 15.4905 12.9954 16.5 11.7549 16.5L7.25488 16.5C6.01438 16.5 5.00488 15.4905 5.00488 14.25L5.00488 5.25C5.00488 4.0095 6.01438 3 7.25488 3L11.7549 3C12.9954 3 14.0049 4.0095 14.0049 5.25ZM6.50488 9.75L6.50488 14.25C6.50488 14.664 6.84088 15 7.25488 15L11.7549 15C12.1689 15 12.5049 14.664 12.5049 14.25L12.5049 9.75C12.5049 9.336 12.1689 9 11.7549 9L7.25488 9C6.84088 9 6.50488 9.336 6.50488 9.75Z",
    fill: "#4B6C87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1933_2621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.504883 18) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryHalf);
export default __webpack_public_path__ + "static/media/battery-half.9dd7f9e445e8b9574984ff2f9897e342.svg";
export { ForwardRef as ReactComponent };